import { PURCHASER_API_BASE_URL, getHeaders } from "../Constants";

export interface SpreadsheetRevision {
    id: string;
    version: number;
    createdAt: string; // ISO 8601 string
    contentJson: Record<string, any>; // Univer snapshot JSON
    createdByUserId: number | null;
    spreadsheetId: string;
}

export interface Spreadsheet {
    id: string;
    name: string;
    createdAt: string; // ISO 8601 string
    updatedAt: string; // ISO 8601 string
    teamId: number;
    createdByUserId: number | null;
    latestRevisionId: string | null;
    latestRevision: SpreadsheetRevision | null;
}

// GET /spreadsheets
export interface ListSpreadsheetsResponse {
    spreadsheets: Spreadsheet[];
}

// GET /spreadsheets/:id
export interface GetSpreadsheetResponse {
    spreadsheet: Spreadsheet;
    content: Record<string, any> | null; // Shortcut to spreadsheet.latestRevision.contentJson
}

export default {
    listSpreadsheets: async (): Promise<ListSpreadsheetsResponse> => {
        const res = await fetch(`${PURCHASER_API_BASE_URL}/spreadsheets`, {
            headers: getHeaders(),
        });
        if (!res.ok) {
            throw new Error(`Failed to list spreadsheets (${res.status}: ${res.statusText})`);
        }
        return res.json();
    },

    getSpreadsheet: async (id: string): Promise<GetSpreadsheetResponse> => {
        const res = await fetch(`${PURCHASER_API_BASE_URL}/spreadsheets/${id}`, {
            headers: getHeaders(),
        });
        if (!res.ok) {
            throw new Error(`Failed to fetch spreadsheet (${res.status}: ${res.statusText})`);
        }
        return res.json();
    },

    exportSpreadsheet: async (id: string): Promise<Response> => {
        const res = await fetch(`${PURCHASER_API_BASE_URL}/spreadsheets/${id}/export`, {
            headers: getHeaders(),
        });
        if (!res.ok) {
            throw new Error(`Failed to export spreadsheet (${res.status}: ${res.statusText})`);
        }
        return res;
    },
};
